import React, { useEffect, useState } from "react";
import { Chat, Streami18n } from "stream-chat-react";
import { streamService } from "../../../utils/StreamService";
import { useTheme } from "../../../hooks/useTheme";
import { useAuth } from "../../../hooks/useAuth";
import { AuthenticationStatus } from "../../../store/slices/authSlice";
import { StreamVideo, StreamTheme, Call, StreamCall, BackgroundFiltersProvider } from "@stream-io/video-react-sdk";
import { useStream } from "../../../hooks/useStream";
import { localeFormatDate } from "../../../utils/Utils";

interface StreamContainerProps {
    children: React.ReactNode;
}

const StreamContainer = ({ children }: StreamContainerProps) => {
    const { isDarkMode } = useTheme();
    const { status } = useAuth();
    const { currentCallData } = useStream();
    const [call, setCall] = useState<Call | undefined>(undefined);

    useEffect(() => {
        setCall(streamService.getCurrentCall());
    }, [currentCallData]);

    const translations: any = {
        "Type your message": "Message",
        "Pin": "Pin Message",
        "Unpin": "Unpin Message",
    }

    if(localeFormatDate === "en-GB") {
        translations["timestamp/DateSeparator"] = "{{ timestamp | timestampFormatter(calendar: false; format: 'DD/MM/YYYY') }}";
        translations["timestamp/MessageTimestamp"] = "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"lastDay\": \"[Yesterday at] LT\", \"lastWeek\": \"[Last] dddd [at] LT\", \"nextDay\": \"[Tomorrow at] LT\", \"nextWeek\": \"dddd [at] LT\", \"sameDay\": \"[Today at] LT\", \"sameElse\": \"DD/MM/YYYY\" }) }}";
    }

    const i18nInstance = new Streami18n({ 
        language: "en",
        translationsForLanguage: translations,
      });

    const renderChildren = () => {
        if(status !== AuthenticationStatus.INITIAL && status !== AuthenticationStatus.LOGGING_OUT) {
            const videoClient = streamService.getVideoClient();
    
            if(videoClient) {
                return <StreamVideo client={videoClient}>
                    <StreamTheme>
                        <StreamCall call={call}>
                            <BackgroundFiltersProvider>
                                {children}
                            </BackgroundFiltersProvider>
                        </StreamCall>
                    </StreamTheme>
                </StreamVideo>
            }
        }

        return children;
    }
    
    return (
        <Chat 
            client={streamService.getChatClient()} 
            theme={isDarkMode ? "str-chat__theme-dark" : "str-chat__theme-light"}
            i18nInstance={i18nInstance}
        >
            {renderChildren()}
        </Chat>
    )
}

export default StreamContainer;